<app-multi-select-input
    [infiniteScroll]="foldersScroll()"
    [form]="form()"
    [id]="id()"
    [label]="label()"
    valueKey="id"
    labelKey="person.fullname"
    filterBy="fullname"
>
    <ng-template #item let-item>
        {{ item.person | formatPerson }}
    </ng-template>
    <ng-template #selectedItems let-items>
        <div class="flex gap-2">
            @for (item of items; track item.id) {
                @if($index < 3) {
                    <p-chip [label]="item.person | formatPerson "></p-chip>
                }
            }
            @if(items?.length > 3) {
                <span class="ml-2">...</span>
            }
        </div>
    </ng-template>
</app-multi-select-input>
